export const BIR_ADDRESS = process.env.REACT_APP_BIR_ADDRESS
export const BGT_ADDRESS = process.env.REACT_APP_BGT_ADDRESS
export const BIC_ADDRESS = process.env.REACT_APP_BIC_ADDRESS
export const BUSD_ADDRESS = process.env.REACT_APP_BUSD_ADDRESS
export const WHITE_LIST_ADDRESS = process.env.REACT_APP_WHITELIST_ADDRESS
export const PRIVATE_SALE_CONTRACT_ADDRESS = process.env.REACT_APP_PRIVATE_SALE_ADDRESS
export const MANAGEMENT_CONTRACT_ADDRESS = process.env.REACT_APP_MANAGEMENT_ADDRESS
export const PAYMENT_CONTRACT_ADDRESS = process.env.REACT_APP_PAYMENT_ADDRESS
export const AIRDROP_ADDRESS = process.env.REACT_APP_AIRDROP_ADDRESS
